import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import Addunits from "../../../../core/modals/inventory/addunits";
import AddCategory from "../../../../core/modals/inventory/addcategory";
import AddBrand from "../../../../core/modals/addbrand";
// import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
// import CounterThree from "../../../../core/common/counter/counterThree";
// import RefreshIcon from "../../../../core/common/tooltip-content/refresh";
// import CollapesIcon from "../../../../core/common/tooltip-content/collapes";
import AddVariant from "../../../../core/modals/inventory/addvariant";
import AddVarientNew from "../../../../core/modals/inventory/addVarientNew";
import {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_EMPLOYEES_LIST,
  ROLL_CALL_IMG_PATH,
} from "../RollCallConfig/RollCallConfig";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import { Spin } from "antd";

const RollcallAdditionalDetails = () => {
  const [employees, setEmployees] = useState([]);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [familyData, setFamilyData] = useState([]);
  const [detailsData, setDetailsData] = useState([]);
  const [proofsData, setProofsData] = useState([]);
  const [bankData, setBankData] = useState([]);
  const [selectedMgnrId, setSelectedMgnrId] = useState(null);
  const [educationData, setEducationData] = useState([]);
  const [hasExistingBankData, setHasExistingBankData] = useState(false);
  const [hasExistingfamilyData, setHasExistingfamilyData] = useState(false);
  const [hasExistingproofsData, setHasExistingproofsData] = useState(false);
  const [hasExistingRegData, setHasExistingRegData] = useState(false);
  const [hasExistingEducationData, setHasExistingEducationData] =
    useState(false);
  const [data, setData] = useState([]);
  const [hasAssignedMgnr, setHasAssignedMgnr] = useState(false);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [previewPath, setPreviewPath] = useState(null);
  const [isLoadingPreview, setIsLoadingPreview] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const [isUploading, setIsUploading] = useState(false);
  const [personalDetLoading, setPersonalDetLoading] = useState(false);
  const [bankDetLoading, setBankDetLoading] = useState(false);
  const [proofsDetLoading, setProofsDetLoading] = useState(false);
  const [familyDetLoading, setFamilyDetLoading] = useState(false);
  const [educationDetLoading, setEducationDetLoading] = useState(false);
  const [mgnrSubmitLoading, setMgnrSubmitLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  console.log(selectedFile);

  const scrollToAccordion = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const yOffset = -120;
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  const userData = JSON.parse(sessionStorage.getItem("userData"));

  const location = useLocation();

  const { regid } = location.state || {};
  const { departmentId } = location.state || {};

  useEffect(() => {
    if (tokenData && superIdData) {
      fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_EMPLOYEES_LIST}?superid=${superIdData}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        },
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          console.log("API Response:", data);
          if (data && data.status) {
            setEmployees(data.ResultData || []);
          } else {
            console.error("Invalid data format:", data);
            setEmployees([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [tokenData, superIdData]);

  useEffect(() => {
    if (tokenData && superIdData && selectedEmp?.value) {
      const fetchEmployeeData = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/emp/getEmployee?superid=${superIdData}&departmentid=${departmentId || selectedEmp?.departmentId || null}&regid=${selectedEmp.value}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          const responseData = await response.json();
          if (responseData.status) {
            setData(responseData.ResultData[0] || []);

            setSelectedMgnrId(
              responseData?.ResultData[0]?.ManagerRegId || null,
            );
            const managerId = responseData?.ResultData?.[0]?.ManagerRegId;
            setHasAssignedMgnr(managerId != null);
          } else {
            console.error("API Error:", responseData.ErrorMsg);
          }
        } catch (error) {
          console.error("Error fetching employee data:", error);
        }
      };

      fetchEmployeeData();
    }
  }, [selectedEmp, superIdData, departmentId, tokenData]);

  const fetchEmployeeDetails = async () => {
    if (!selectedEmp || !selectedEmp.value) {
      console.warn("No employee selected or invalid data", selectedEmp);
      return;
    }

    setIsLoading(true);

    try {
      const urls = [
        `${ROLL_CALL_API_BASE_URL}portal/emp/getRegFamily?regid=${selectedEmp.value}`,
        `${ROLL_CALL_API_BASE_URL}portal/emp/getRegDetails?regid=${selectedEmp.value}`,
        `${ROLL_CALL_API_BASE_URL}portal/emp/getRegProofs?regid=${selectedEmp.value}`,
        `${ROLL_CALL_API_BASE_URL}portal/emp/getRegBankDetails?regid=${selectedEmp.value}`,
        `${ROLL_CALL_API_BASE_URL}portal/education/getRegeducationdetails?regid=${selectedEmp.value}&superid=${superIdData}`,
      ];

      const responses = await Promise.all(
        urls?.map((url) =>
          fetch(url, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
          }).then((res) => {
            if (!res.ok) {
              throw new Error(`Failed to fetch: ${url} Status: ${res.status}`);
            }
            return res.json();
          }),
        ),
      );

      const [familyRes, detailsRes, proofsRes, bankRes, educationRes] =
        responses;

      const familyDataArray = familyRes?.ResultData || [];
      const detailsDataArray = detailsRes?.ResultData || [];
      const proofsDataArray = proofsRes?.ResultData || [];
      const bankDataArray = bankRes?.ResultData || [];
      const educationDataArray = educationRes?.ResultData || [];

      setFamilyData(familyDataArray[0]);
      setDetailsData(detailsDataArray[0]);
      setProofsData(proofsDataArray[0]);
      setBankData(bankDataArray[0]);
      setEducationData(educationDataArray[0]);

      setHasExistingfamilyData(familyDataArray?.length > 0);
      setHasExistingRegData(detailsDataArray?.length > 0);
      setHasExistingproofsData(proofsDataArray?.length > 0);
      setHasExistingBankData(bankDataArray?.length > 0);
      setHasExistingEducationData(educationDataArray?.length > 0);
    } catch (error) {
      console.error("Error fetching employee details:", error);
      setHasExistingfamilyData(false);
      setHasExistingRegData(false);
      setHasExistingproofsData(false);
      setHasExistingBankData(false);
      setHasExistingEducationData(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (tokenData) {
      fetchEmployeeDetails();
    }
  }, [selectedEmp?.value, tokenData, superIdData]);

  const handleUpload = async (file, type) => {
    if (!file || !superIdData || !tokenData || !selectedEmp?.value || !type) {
      alert("Missing data");
      return;
    }
    setIsUploading(true);

    const formData = new FormData();
    formData.append("files", file);
    formData.append("superid", superIdData);
    formData.append("RegId", selectedEmp.value);
    formData.append("fileType", type);

    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/fileupload/UploadEmpImages`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${tokenData}`,
          },
          body: formData,
        },
      );

      if (!response.ok) {
        const errorData = await response.text();
        console.error("Upload failed:", errorData);
        alert("Image upload failed");
        return;
      }

      const result = await response.json();
      console.log("Upload Success:", result);
      alert("Image uploaded successfully");
      setSelectedFile(null);

      setFileInputKey(Date.now());

      setTimeout(() => {
        fetchUploadedImages();
      }, 2000);
    } catch (error) {
      console.error("Upload Error:", error);
      alert("Image upload failed");
    } finally {
      setIsUploading(false);
    }
  };

  const handleImageChange = (event, type) => {
    const file = event.target.files[0];
    console.log(file);
    console.log(type);
    if (file) {
      setSelectedFile(file);
      handleUpload(file, type);
    }
  };

  const fetchUploadedImages = async () => {
    const url = new URL(
      `${ROLL_CALL_API_BASE_URL}portal/fileupload/empfilepaths`,
    );
    url.searchParams.append("superid", superIdData);
    url.searchParams.append("regid", selectedEmp.value);

    try {
      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Error fetching images:", errorText);
        // alert("Failed to fetch uploaded images");
        return;
      }

      const result = await response.json();
      setUploadedFiles(result?.ResultData || []);
      console.log("Uploaded image paths:", result);
    } catch (error) {
      console.error("Fetch error:", error);
      // alert("Error fetching uploaded images");
    }
  };

  useEffect(() => {
    if (superIdData && selectedEmp?.value && tokenData) {
      fetchUploadedImages();
    }
  }, [superIdData, selectedEmp?.value, tokenData]);

  const handleDownload = async (filePath) => {
    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/fileupload/empfiledownload?path=${encodeURIComponent(
          filePath,
        )}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenData}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error("File download failed");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = filePath.split("/").pop();
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      alert("Download failed");
    }
  };

  const handlePreview = (filePath) => {
    setIsLoadingPreview(true);
    setIsLoading(true);
    const fullUrl = `${ROLL_CALL_IMG_PATH}${filePath}`;

    const img = new Image();
    img.src = fullUrl;

    img.onload = () => {
      setPreviewPath(fullUrl);
      setIsLoadingPreview(false);
      setIsLoading(false);
    };

    img.onerror = () => {
      alert("Failed to load image");
      setIsLoadingPreview(false);
      setIsLoading(false);
    };
  };

  const closePreview = () => {
    setPreviewPath(null);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const empOptions = useMemo(() => {
    return employees?.map((emp) => ({
      value: emp.RegId,
      departmentId: emp.DepartmentId,
      label: emp.UserName,
    }));
  }, [employees]);

  useEffect(() => {
    if (regid && empOptions?.length > 0) {
      setIsLoading(true);
      const selected = empOptions.find((emp) => emp.value === regid);
      setSelectedEmp(selected || null);
      setIsLoading(false);
    }
  }, [regid, empOptions]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBankData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDetailsChange = (e) => {
    const { name, value } = e.target;
    setDetailsData((prev) => ({ ...prev, [name]: value }));
  };

  const handleproofchnage = (e) => {
    const { name, value } = e.target;
    setProofsData((prev) => ({ ...prev, [name]: value }));
  };

  const handlefamilychnage = (e) => {
    const { name, value } = e.target;
    setFamilyData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEducationchnage = (e) => {
    const { name, value } = e.target;
    setEducationData((prev) => ({ ...prev, [name]: value }));
  };

  const saveProofDetails = async (e) => {
    e.preventDefault();
    if (tokenData && superIdData && userData?.UserId) {
      // if (!proofsData?.length) return;
      setIsLoading(true);
      setProofsDetLoading(true);

      const updatedData = {
        regid: selectedEmp.value,
        superid: superIdData,
        createdby: userData?.UserId,
        pan: proofsData.pan,
        uan: proofsData.uan,
        adhaar: proofsData.adhaar,
        esi: proofsData.esi || "",
        pf: proofsData.pf,
        epfstart: proofsData.EPFStart || "",
        voterid: proofsData.VoterId,
      };
      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/emp/createRegProofs`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(updatedData),
          },
        );

        const result = await response.json();
        if (response.ok && result.status) {
          Swal.fire({
            title: "Created!",
            text: "Proof details created successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            fetchEmployeeDetails();
          });
        } else {
          Swal.fire(
            "Error",
            result.ErrorMsg || "Failed to save details",
            "error",
          );
        }
      } catch (error) {
        console.error("Error updating bank details:", error);
        alert("Error updating bank details.");
      }
    }
    setProofsDetLoading(false);
  };

  const saveRegDetails = async (e) => {
    e.preventDefault();
    if (tokenData && superIdData) {
      if (
        !detailsData ||
        (Array.isArray(detailsData) && detailsData.length === 0) ||
        (typeof detailsData === "object" &&
          Object.keys(detailsData).length === 0)
      )
        return;
      setIsLoading(true);
      setPersonalDetLoading(true);
      const payload = {
        regid: selectedEmp.value,
        superid: superIdData,
        emailid: detailsData.emailid || "",
        emergencycontactno1: detailsData.EmergencyContactNo1 || "",
        emergencycontactno2: detailsData.EmergencyContactNo2 || "",
        currentAddress: detailsData.CurrentAddress || "",
        permanentAddress: detailsData.PermanentAddress || "",
      };

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/emp/createRegDetails`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(payload),
          },
        );

        const result = await response.json();
        if (response.ok && result.status) {
          Swal.fire({
            title: "Created!",
            text: "Registeted details created successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            fetchEmployeeDetails();
          });
        } else {
          Swal.fire(
            "Error",
            result.ErrorMsg || "Failed to save details",
            "error",
          );
        }
      } catch (error) {
        console.error("Error saving personal details:", error);
        Swal.fire("Error", "Something went wrong", "error");
      }
    }
    setPersonalDetLoading(false);
    setIsLoading(false);
  };
  const saveMgnrDetails = async (e) => {
    e.preventDefault();
    if (tokenData && superIdData && selectedMgnrId) {
      if (
        !data ||
        (Array.isArray(data) && data.length === 0) ||
        (typeof data === "object" && Object.keys(data).length === 0)
      )
        return;
      if (selectedEmp.value === selectedMgnrId) {
        Swal.fire(
          "Error",
          "Selected Employee and manager should not be same",
          "error",
        );
        return;
      }
      setIsLoading(true);
      setMgnrSubmitLoading(true);
      const payload = {
        regid: selectedEmp.value,
        superid: superIdData,
        managerRegId: selectedMgnrId,
        userId: userData?.UserId,
      };

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/team/addteammember`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(payload),
          },
        );

        const result = await response.json();
        if (response.ok && result.status) {
          Swal.fire({
            title: "Created!",
            text: "Manager Assigned successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            fetchEmployeeDetails();
          });
        } else {
          Swal.fire(
            "Error",
            result.ErrorMsg || "Failed to save details",
            "error",
          );
        }
      } catch (error) {
        console.error("Error saving Manager details:", error);
        Swal.fire("Error", "Something went wrong", "error");
      }
    }
    setMgnrSubmitLoading(false);
    setIsLoading(false);
  };

  const savefamilyDetails = async (e) => {
    e.preventDefault();
    if (tokenData && superIdData && userData?.UserId) {
      if (
        !familyData ||
        (Array.isArray(familyData) && familyData.length === 0) ||
        (typeof familyData === "object" && Object.keys(familyData).length === 0)
      )
        return;
      setFamilyDetLoading(true);
      setIsLoading(true);
      const updatedData = {
        regid: selectedEmp.value,
        superid: superIdData,
        Name: familyData.Name,
        Relation: familyData.Relation,
        DateOfBirth: "03-09-2023",
        Age: familyData.Age,
        CreatedBy: userData?.UserId,
      };

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/emp/createRegFamily`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(updatedData),
          },
        );

        const result = await response.json();
        if (response.ok && result.status) {
          Swal.fire({
            title: "Created!",
            text: "Family details created successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            fetchEmployeeDetails();
          });
        } else {
          Swal.fire(
            "Error",
            result.ErrorMsg || "Failed to save details",
            "error",
          );
        }
      } catch (error) {
        console.error("Error updating family details:", error);
        alert("Error updating family details.");
      }
    }
    setFamilyDetLoading(false);
    setIsLoading(false);
  };

  const saveBankDetails = async (e) => {
    e.preventDefault();
    if (tokenData && superIdData && userData?.UserId) {
      if (
        !bankData ||
        (Array.isArray(bankData) && bankData.length === 0) ||
        (typeof bankData === "object" && Object.keys(bankData).length === 0)
      )
        return;
      setIsLoading(true);
      setBankDetLoading(true);
      const updatedData = {
        regid: selectedEmp.value,
        superid: superIdData,
        createdby: userData?.UserId,
        accountNo: bankData.AccountNo,
        accountholdersname: bankData.AccountHoldersName,
        bankName: bankData.BankName,
        bankbranch: bankData.BankBranch,
        ifsccode: bankData.IfscCode,
      };

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/emp/createRegBankDetails`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(updatedData),
          },
        );

        const result = await response.json();
        if (response.ok && result.status) {
          Swal.fire({
            title: "Created!",
            text: "bank details created successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            fetchEmployeeDetails();
          });
        } else {
          Swal.fire(
            "Error",
            result.ErrorMsg || "Failed to save details",
            "error",
          );
        }
      } catch (error) {
        console.error("Error save bank details:", error);
        alert("Error save bank details.");
      }
    }
    setBankDetLoading(false);
    setIsLoading(false);
  };

  const saveEducationDetails = async (e) => {
    e.preventDefault();
    if (tokenData && superIdData && userData?.UserId) {
      if (
        !educationData ||
        (Array.isArray(educationData) && educationData.length === 0) ||
        (typeof educationData === "object" &&
          Object.keys(educationData).length === 0)
      )
        return;
      setIsLoading(true);
      setEducationDetLoading(true);
      const updatedData = {
        RegId: selectedEmp.value,
        superid: superIdData,
        createdby: userData?.UserId,
        qualification: educationData.Qualification,
        college: educationData.College,
        university: educationData.University,
        percentage: educationData.Percentage,
      };

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/education/createRegeducationdetails`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(updatedData),
          },
        );

        const result = await response.json();
        if (response.ok && result.status) {
          Swal.fire({
            title: "Created!",
            text: "Education details created successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            fetchEmployeeDetails();
          });
        } else {
          Swal.fire(
            "Error",
            result.ErrorMsg || "Failed to save details",
            "error",
          );
        }
      } catch (error) {
        console.error("Error save bank details:", error);
        alert("Error save bank details.");
      } finally {
        setEducationDetLoading(false);
        setIsLoading(false);
      }
    }
  };

  const UpdateEducationDetails = async (e) => {
    e.preventDefault();
    if (tokenData && superIdData && userData?.UserId) {
      if (
        !educationData ||
        (Array.isArray(educationData) && educationData.length === 0) ||
        (typeof educationData === "object" &&
          Object.keys(educationData).length === 0)
      )
        return;
      setIsLoading(true);
      setEducationDetLoading(true);
      const payload = {
        educationid: educationData.Id,
        RegId: selectedEmp.value,
        superid: superIdData,
        qualification: educationData.Qualification || "",
        college: educationData.College || "",
        university: educationData.University || "",
        percentage: educationData.Percentage || "",
        UpdatedBy: userData?.UserId,
      };

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/education/updateRegeducationdetails`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(payload),
          },
        );

        const result = await response.json();
        if (response.ok && result.status) {
          Swal.fire({
            title: "Created!",
            text: "Education details updated successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            fetchEmployeeDetails();
          });
        } else {
          Swal.fire(
            "Error",
            result.ErrorMsg || "Failed to update details",
            "error",
          );
        }
      } catch (error) {
        console.error("Error updating Register details:", error);
        Swal.fire("Error", "Something went wrong", "error");
      }
    }
    setEducationDetLoading(false);
    setIsLoading(false);
  };

  const UpdateRegDetails = async (e) => {
    e.preventDefault();
    if (tokenData && superIdData) {
      if (
        !detailsData ||
        (Array.isArray(detailsData) && detailsData.length === 0) ||
        (typeof detailsData === "object" &&
          Object.keys(detailsData).length === 0)
      )
        return;
      setIsLoading(true);
      setPersonalDetLoading(true);
      const payload = {
        regid: selectedEmp.value,
        superid: superIdData,
        emailid: detailsData.emailid || "",
        emergencycontactno1: detailsData.EmergencyContactNo1 || "",
        emergencycontactno2: detailsData.EmergencyContactNo2 || "",
        currentAddress: detailsData.CurrentAddress || "",
        permanentAddress: detailsData.PermanentAddress || "",
      };

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/emp/updateRegDetails`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(payload),
          },
        );

        const result = await response.json();
        if (response.ok && result.status) {
          Swal.fire({
            title: "Created!",
            text: "Register details updated successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            fetchEmployeeDetails();
          });
        } else {
          Swal.fire(
            "Error",
            result.ErrorMsg || "Failed to update details",
            "error",
          );
        }
      } catch (error) {
        console.error("Error updating Register details:", error);
        Swal.fire("Error", "Something went wrong", "error");
      }
    }
    setPersonalDetLoading(false);
    setIsLoading(false);
  };

  const updatefamilyDetails = async (e) => {
    e.preventDefault();
    if (tokenData && superIdData && userData?.UserId) {
      if (
        !familyData ||
        (Array.isArray(familyData) && familyData.length === 0) ||
        (typeof familyData === "object" && Object.keys(familyData).length === 0)
      )
        return;
      setIsLoading(true);
      setFamilyDetLoading(true);
      const updatedData = {
        regid: selectedEmp.value,
        superid: superIdData,
        Name: familyData.Name,
        Relation: familyData.Relation,
        DateOfBirth: "03-09-2023",
        Age: familyData.Age,
        UpdatedBy: userData?.UserId,
      };

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/emp/updateRegFamily`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(updatedData),
          },
        );

        const result = await response.json();
        if (response.ok && result.status) {
          Swal.fire({
            title: "Created!",
            text: "family details updated successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            fetchEmployeeDetails();
          });
        } else {
          Swal.fire(
            "Error",
            result.ErrorMsg || "Failed to save details",
            "error",
          );
        }
      } catch (error) {
        console.error("Error updating family details:", error);
        alert("Error updating family details.");
      }
    }
    setFamilyDetLoading(false);
    setIsLoading(false);
  };

  const updateBankDetails = async (e) => {
    e.preventDefault();
    if (tokenData && superIdData && userData?.UserId) {
      if (
        !bankData ||
        (Array.isArray(bankData) && bankData.length === 0) ||
        (typeof bankData === "object" && Object.keys(bankData).length === 0)
      )
        setIsLoading(true);
      setBankDetLoading(true);
      const updatedData = {
        regid: selectedEmp.value,
        superid: superIdData,
        createdby: userData?.UserId,
        accountNo: bankData.AccountNo,
        accountholdersname: bankData.AccountHoldersName,
        bankName: bankData.BankName,
        bankbranch: bankData.BankBranch,
        ifsccode: bankData.IfscCode,
      };

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/emp/updateRegBankDetails`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(updatedData),
          },
        );

        const result = await response.json();
        if (response.ok && result.status) {
          Swal.fire({
            title: "Created!",
            text: "bank details updated successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            fetchEmployeeDetails();
          });
        } else {
          Swal.fire(
            "Error",
            result.ErrorMsg || "Failed to save details",
            "error",
          );
        }
      } catch (error) {
        console.error("Error updating bank details:", error);
        alert("Error updating bank details.");
      } finally {
        setBankDetLoading(false);
        setIsLoading(false);
      }
    }
  };

  const updateMgnrDetails = async (e) => {
    e.preventDefault();
    if (tokenData && superIdData && selectedMgnrId) {
      if (
        !data ||
        (Array.isArray(data) && data.length === 0) ||
        (typeof data === "object" && Object.keys(data).length === 0)
      )
        return;
      if (selectedEmp.value === selectedMgnrId) {
        Swal.fire(
          "Error",
          "Selected Employee and manager should not be same",
          "error",
        );
        return;
      }
      setIsLoading(true);
      setMgnrSubmitLoading(true);
      const payload = {
        regid: selectedEmp.value,
        superid: superIdData,
        managerRegId: selectedMgnrId,
        userId: userData?.UserId,
        EmpManagerId: data?.EmpManagerId,
      };

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/team/UpdateAssignedManager`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(payload),
          },
        );

        const result = await response.json();
        if (response.ok && result.status) {
          Swal.fire({
            title: "Created!",
            text: "Manager Assigned successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            fetchEmployeeDetails();
          });
        } else {
          Swal.fire(
            "Error",
            result.ErrorMsg || "Failed to save details",
            "error",
          );
        }
      } catch (error) {
        console.error("Error saving Manager details:", error);
        Swal.fire("Error", "Something went wrong", "error");
      }
    }
    setMgnrSubmitLoading(false);
    setIsLoading(false);
  };

  const updateProofDetails = async (e) => {
    e.preventDefault();
    if (tokenData && superIdData && userData?.UserId) {
      // if (!proofsData?.length) return;
      setProofsDetLoading(true);
      setIsLoading(true);
      const updatedData = {
        regid: selectedEmp.value,
        superid: superIdData,
        createdby: userData?.UserId,
        pan: proofsData.pan,
        uan: proofsData.uan,
        adhaar: proofsData.adhaar,
        esi: proofsData.esi,
        pf: proofsData.pf,
        epfstart: proofsData.EPFStart,
        voterid: proofsData.VoterId,
      };
      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/emp/updateRegProofs`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(updatedData),
          },
        );

        const result = await response.json();
        if (response.ok && result.status) {
          Swal.fire({
            title: "Created!",
            text: "proofs details updated successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            fetchEmployeeDetails();
          });
        } else {
          Swal.fire(
            "Error",
            result.ErrorMsg || "Failed to save details",
            "error",
          );
        }
      } catch (error) {
        console.error("Error updating proof details:", error);
        alert("Error updating proof details.");
      }
    }
    setProofsDetLoading(false);
    setIsLoading(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const generatePDF = async () => {
    const doc = new jsPDF();
    doc.rect(10, 10, 190, 277);
    let y = 20;

    const leftX = 14;
    const rightX = 110;

    const imgPath = process.env.PUBLIC_URL + "/assets/img/logo.png";
    const imgWidth = 30;
    const imgHeight = 8;
    const imgX = 15;
    const imgY = 15;

    doc.addImage(imgPath, "PNG", imgX, imgY, imgWidth, imgHeight);

    doc.setFontSize(18);
    doc.setTextColor(0, 0, 128);
    doc.text("", 105, y, null, null, "center");

    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}/${
      currentDate.getMonth() + 1
    }/${currentDate.getFullYear()}`;
    const pageWidth = doc.internal.pageSize.width;
    const textWidth = doc.getTextWidth(formattedDate);

    doc.setFontSize(10);
    doc.text(`Dt: ${formattedDate}`, pageWidth - textWidth - 8, y);

    y += 8;

    // Helper to load image and convert to base64
    const getImageBase64 = (url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/jpeg")); // or "image/png"
        };
        img.onerror = reject;
        img.src = url;
      });
    };

    const addSection = async (title, obj, fields) => {
      doc.setFillColor(204, 229, 255);
      doc.rect(leftX, y, 182, 8, "F");

      doc.setFontSize(13);
      doc.setTextColor(0, 0, 128);
      doc.text(title, leftX + 2, y + 6);

      y += 8;
      y += 8;

      if (title === "Personal Information") {
        const fileImage = uploadedFiles?.find((file) => file.FileType === 1);
        const imageUrl = fileImage
          ? `${ROLL_CALL_IMG_PATH}${fileImage.FilePath}`
          : process.env.PUBLIC_URL + "/assets/img/noImage.png";

        let imageBase64;
        try {
          imageBase64 = await getImageBase64(imageUrl);
        } catch (e) {
          imageBase64 = await getImageBase64(
            process.env.PUBLIC_URL + "/assets/img/noImage.png",
          );
        }

        const imageX = leftX;
        const imageY = y - 5;
        const imageWidth = 35;
        const imageHeight = 35;
        doc.addImage(
          imageBase64,
          "JPEG",
          imageX,
          imageY,
          imageWidth,
          imageHeight,
        );

        const gapAfterImage = 10;
        const fieldSpacing = 80;

        const row1Y = imageY + 10;
        const row2Y = imageY + 22;

        let currentX = imageX + imageWidth + gapAfterImage;

        doc.setFontSize(11);
        doc.setTextColor(0);

        doc.setFont(undefined, "bold");
        doc.text("Employee Name:", currentX, row1Y);

        doc.setFont(undefined, "normal");
        const employeeNameX = currentX + 35;
        const employeeName = data?.UserName || "N/A";
        doc.text(employeeName, employeeNameX, row1Y);
        doc.line(
          employeeNameX,
          row1Y + 2,
          currentX + fieldSpacing - 5,
          row1Y + 2,
        );

        currentX = currentX + fieldSpacing;

        doc.setFont(undefined, "bold");
        doc.text("Emp ID:", currentX, row1Y);

        doc.setFont(undefined, "normal");
        const empIdX = currentX + 20;
        const empId = data?.Badge || "N/A";
        doc.text(empId, empIdX, row1Y);
        doc.line(empIdX, row1Y + 2, empIdX + 30, row1Y + 2);

        // Second row
        currentX = imageX + imageWidth + gapAfterImage;

        doc.setFont(undefined, "bold");
        doc.text("Bio ID:", currentX, row2Y);

        doc.setFont(undefined, "normal");
        const bioIdX = currentX + 35;
        const bioId = data?.CardId || "N/A";
        doc.text(bioId, bioIdX, row2Y);
        doc.line(bioIdX, row2Y + 2, bioIdX + 40, row2Y + 2);

        currentX = currentX + fieldSpacing;

        doc.setFont(undefined, "bold");
        doc.text("RFID:", currentX, row2Y);

        doc.setFont(undefined, "normal");
        const rfidX = currentX + 20;
        const rfid = data?.RFID || "N/A";
        doc.text(rfid, rfidX, row2Y);
        doc.line(rfidX, row2Y + 2, rfidX + 40, row2Y + 2);

        y = imageY + imageHeight + 5;
      }

      doc.setFontSize(11);
      doc.setTextColor(0);

      let tempY = y;
      let isLeft = true;

      for (const { label, key } of fields) {
        const x = isLeft ? leftX : rightX;
        let value =
          typeof key === "string"
            ? (obj?.[key] ?? "")
            : typeof key === "function"
              ? key()
              : "";

        value =
          typeof value === "string"
            ? value.trim()
            : value?.toString?.().trim?.() || "N/A";

        doc.setFont(undefined, "bold");
        doc.text(`${label}:`, x, tempY);
        doc.setFont(undefined, "normal");
        doc.text(value, x + 45, tempY);

        const valWidth = doc.getTextWidth(value);
        doc.line(x + 45, tempY + 1, x + 45 + Math.max(40, valWidth), tempY + 1);

        if (!isLeft) tempY += 8;
        isLeft = !isLeft;

        if (tempY > 280) {
          doc.addPage();
          tempY = 20;
        }
      }

      if (!isLeft) tempY += 8;
      y = tempY;
    };

    const formatDate = (dateString) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      return isNaN(date) ? "" : date.toLocaleDateString();
    };

    const checkGender = (gender) => (gender == 1 ? "Male" : "Female");

    // Sections
    await addSection("Personal Information", data, [
      { label: "Gender", key: () => checkGender(data?.Gender) },
      { label: "Designation", key: "Designation" },
      { label: "Department", key: "Departmentname" },
      { label: "Branch", key: "branchname" },
      { label: "DOJ", key: () => formatDate(data?.DateOfJoining) },
      { label: "Mobile", key: "Mobile" },
    ]);

    await addSection("Contact Information", detailsData, [
      { label: "Email", key: "emailid" },
      { label: "Contact 1", key: "EmergencyContactNo1" },
      { label: "Contact 2", key: "EmergencyContactNo2" },
      { label: "Current Add.", key: "CurrentAddress" },
      { label: "Permanent Add.", key: "PermanentAddress" },
    ]);

    await addSection("Education Details", detailsData, [
      { label: "Qualification", key: "emailid" },
      { label: "College", key: "EmergencyContactNo1" },
      { label: "University", key: "EmergencyContactNo2" },
      { label: "Percentage", key: "CurrentAddress" },
    ]);

    await addSection("Bank Details", bankData, [
      { label: "Acc.No", key: "AccountNo" },
      { label: "Acc. Holder", key: "AccountHoldersName" },
      { label: "Bank Name", key: "BankName" },
      { label: "Branch", key: "BankBranch" },
      { label: "IFSC Code", key: "IfscCode" },
    ]);

    await addSection("Proofs", proofsData, [
      { label: "PAN", key: "pan" },
      { label: "Aadhaar", key: "adhaar" },
      { label: "UAN", key: "uan" },
      { label: "Voter", key: "VoterId" },
    ]);

    await addSection("Family Details", familyData, [
      { label: "Name", key: "Name" },
      { label: "Relation", key: "Relation" },
      { label: "Date of Birth", key: () => formatDate(data?.DateOfBirth) },
      { label: "Age", key: "Age" },
    ]);

    const pageHeight = doc.internal.pageSize.getHeight();
    const footerY = pageHeight - 10;

    doc.setFontSize(9);
    doc.setTextColor(150);
    doc.text("2025 © Perennial Code. All Right Reserved", 10, footerY);

    const rightFooterText = "Designed & Developed by Perennial Code";
    const footerWidth = doc.getTextWidth(rightFooterText);
    doc.text(rightFooterText, pageWidth - footerWidth - 10, footerY);

    doc.save("EmployeeDetails.pdf");
  };

  const typeLabels = {
    1: "Profile Picture",
    2: "PAN Number",
    3: "Aadhar Number",
    4: "Voter Id",
    5: "Education Certificate",
  };

  const handleDeleteImage = async (imageFile) => {
    console.log(imageFile, "Deleting profile image");

    if (superIdData && tokenData) {
      try {
        const queryParams = new URLSearchParams({
          superid: superIdData,
          regid: selectedEmp?.value,
          ImageId: imageFile.Id,
        });

        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/fileupload/empfilesdelete?${queryParams.toString()}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${tokenData}`,
            },
          },
        );

        if (response.ok) {
          const updated = uploadedFiles.filter(
            (file) => file.Id !== imageFile.Id,
          );
          setUploadedFiles(updated);
          console.log("Image deleted successfully");
        } else {
          console.error("Failed to delete image");
        }
      } catch (error) {
        console.error("Error deleting image", error);
      }
    }
  };
  return (
    <>
      {isUploading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="text-center my-4">
            <Spin size="large"></Spin>
            <p>Loading data...</p>
          </div>
        </div>
      )}

      {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header m-1">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Staff Details
                    </h4>
                  </ol>
                </nav>
              </div>
            </div>

            <ul className="table-top-head">
              {/* <RefreshIcon /> */}
              <div className="col-12 " style={{ width: 200 }}>
                {/* <label className="form-label">Employee</label> */}
                <Select
                  placeholder="Choose Employee"
                  value={selectedEmp}
                  onChange={setSelectedEmp}
                  options={empOptions}
                  styles={{
                    container: (base) => ({ ...base, width: 200 }),
                  }}
                />
              </div>
            </ul>
          </div>
          {/* /add */}
          <div className="d-flex justify-content-between">
            <div className="d-flex mb-2">
              <button
                className="btn me-2 border border-primary"
                onClick={() => scrollToAccordion("ProfileDetails")}
              >
                <i className="fa-regular fa-id-card text-primary me-2"></i>
                Profile
              </button>
              <button
                className="btn me-2 border border-secondary"
                onClick={() => scrollToAccordion("PersonalDetails")}
              >
                <i className="fa-regular fa-id-badge text-secondary me-2"></i>
                Personal
              </button>
              <button
                className="btn me-2 border border-success"
                onClick={() => scrollToAccordion("BankDetails")}
              >
                <i className="fa-solid fa-building-columns me-2 text-success"></i>
                Bank
              </button>
              <button
                className="btn me-2 border border-danger"
                onClick={() => scrollToAccordion("EmployeeProofs")}
              >
                <i className="fa-regular fa-paste text-danger me-2"></i>
                Employee
              </button>
              <button
                className="btn me-2 border border-info"
                onClick={() => scrollToAccordion("FamilyDetails")}
              >
                <i className="fa-solid fa-users text-info me-2"></i>
                Family
              </button>
              <button
                className="btn me-2 border border-secondary"
                onClick={() => scrollToAccordion("EducationDetails")}
              >
                <i className="fa-solid fa-user-graduate text-secondary me-2"></i>
                Education
              </button>
              <button
                className="btn me-2 border border-secondary"
                onClick={() => scrollToAccordion("FilesDetails")}
              >
                <i className="fa-solid fa-file text-info me-2"></i>
                Files
              </button>
            </div>
            <button onClick={generatePDF} className="btn border border-0">
              <i className="fa-solid fa-file-pdf text-danger fs-4"></i>
            </button>
          </div>
          <div className="add-product">
            <div
              className="accordions-items-seperate"
              id="accordionSpacingExample"
            >
              {/* Profile Details */}
              <div className="accordion-item border mb-4" id="ProfileDetails">
                <h2 className="accordion-header" id="headingSpacingOne">
                  <div
                    className="accordion-button collapsed bg-white"
                    data-bs-toggle="collapse"
                    data-bs-target="#SpacingOne"
                    aria-expanded="true"
                    aria-controls="SpacingOne"
                  >
                    <div className="d-flex align-items-center justify-content-between flex-fill">
                      <h5 className="d-flex align-items-center">
                        <i className="fa-regular fa-id-card text-primary me-2"></i>

                        <span>Profile Information</span>
                      </h5>
                    </div>
                  </div>
                </h2>
                <div
                  id="SpacingOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingSpacingOne"
                >
                  <div className="accordion-body border-top">
                    <div className="row d-flex align-items-center">
                      {/* <div className="col-6 col-md-4 col-lg-3 col-12">
                        <label className="form-label">
                          Profile Img <span className="text-danger ms-1">*</span>
                        </label>
                        <div className="uploaded-img-preview d-flex justify-content-center">
                          {uploadedFiles?.find(file => file.FileType === 1) ? (
                            <img
                              src={`${ROLL_CALL_IMG_PATH}${uploadedFiles.find(file => file.FileType === 1)?.FilePath}`}
                              alt="Profile"
                              style={{
                                width: "140px",
                                height: "150px",
                                borderRadius: "5px",
                                objectFit: "cover"
                              }}
                            />
                          ) : (
                            <input
                              type="file"
                              key={fileInputKey}
                              className="form-control"
                              accept="image/png, image/jpeg"
                              onChange={(e) => handleImageChange(e, 1)}
                            />
                          )}
                        </div>
                      </div> */}

                      <div className="col-12 col-md-6 col-lg-2">
                        <label className="form-label">
                          Profile Img{" "}
                          <span className="text-danger ms-1">*</span>
                        </label>
                        <div className="profile-pic-upload ">
                          <div className="profile-pic position-relative">
                            <div className="image-upload mb-0">
                              <input
                                type="file"
                                key={fileInputKey}
                                className="d-none"
                                accept="image/png, image/jpeg"
                                onChange={(e) => handleImageChange(e, 1)}
                                id="profileImageInput"
                              />

                              <label
                                htmlFor="profileImageInput"
                                style={{ cursor: "pointer" }}
                              >
                                {uploadedFiles?.find(
                                  (file) => file.FileType === 1,
                                ) ? (
                                  <>
                                    <img
                                      src={`${ROLL_CALL_IMG_PATH}${
                                        uploadedFiles.find(
                                          (file) => file.FileType === 1,
                                        )?.FilePath
                                      }`}
                                      alt="Profile"
                                      style={{
                                        width: "120px",
                                        height: "120px",
                                        borderRadius: "8px",
                                        objectFit: "cover",
                                      }}
                                    />

                                    <button
                                      type="button"
                                      className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1 p-1 rounded-circle"
                                      onClick={() =>
                                        handleDeleteImage(
                                          uploadedFiles.find(
                                            (file) => file.FileType === 1,
                                          ),
                                        )
                                      }
                                    >
                                      &times;
                                    </button>
                                  </>
                                ) : (
                                  <div
                                    className="image-uploads d-flex flex-column align-items-center justify-content-center border rounded p-3 bg-light"
                                    style={{
                                      width: "140px",
                                      height: "150px",
                                    }}
                                  >
                                    <i className="ti ti-circle-plus fs-16 mb-2" />
                                    <span>Upload Image</span>
                                  </div>
                                )}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-6 col-md-4 col-lg-3 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Employee Id
                            <span className="text-danger ms-1"></span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter biometric id"
                            value={data?.Badge || "N/A"}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Name
                            <span className="text-danger ms-1"></span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Name"
                            value={data?.UserName || "N/A"}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-6 col-md-4 col-lg-3 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Biometric Id
                            <span className="text-danger ms-1"></span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter biometric id"
                            value={data?.CardId || "N/A"}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="col-6 col-md-4 col-lg-3 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Mobile
                            <span className="text-danger ms-1"></span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter mobiel no"
                            value={data?.Mobile || "N/A"}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Email<span className="text-danger ms-1"></span>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Enter email address"
                            value={detailsData?.emailid || "N/A"}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-12">
                        <div className="mb-3">
                          <label className="form-label">Date of Joining</label>
                          <input
                            type="text"
                            className="form-control"
                            disabled
                            value={formatDate(data?.DateOfJoining) || "N/A"}
                          ></input>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Department
                            <span className="text-danger ms-1"></span>
                          </label>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Department"
                            value={data?.DepartmentName || "N/A"}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Designation
                            <span className="text-danger ms-1"></span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter designation"
                            value={data?.Designation || "N/A"}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Branch
                            <span className="text-danger ms-1"></span>
                          </label>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Branch"
                            value={data?.BranchName || "N/A"}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-4 col-lg-3 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            RFID<span className="text-danger ms-1"></span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter RFID"
                            value={data?.RFID || "N/A"}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Manager<span className="text-danger ms-1"></span>
                          </label>
                          <Select
                            placeholder="Select Manager"
                            value={
                              empOptions?.find(
                                (opt) => opt.value === selectedMgnrId,
                              ) || null
                            }
                            onChange={(option) =>
                              setSelectedMgnrId(option?.value)
                            }
                            options={empOptions}
                            menuPortalTarget={document.body}
                            styles={{
                              container: (base) => ({ ...base, width: 200 }),
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 ">
                        <div className="d-flex align-items-center justify-content-end mb-4">
                          {!hasAssignedMgnr ? (
                            <button
                              type="submit"
                              className="btn btn-secondary me-2"
                              onClick={saveMgnrDetails}
                            >
                              {mgnrSubmitLoading ? "Saving..." : "Save"}
                            </button>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={updateMgnrDetails}
                            >
                              {mgnrSubmitLoading ? "Updating..." : "Update"}
                            </button>
                          )}
                        </div>
                      </div>
                      {/* <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Employeement Type
                              <span className="text-danger ms-1">*</span>
                            </label>
                            <Select
                              classNamePrefix="react-select"
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              options={emptype}
                              placeholder="Choose emp type"
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                          <div className="mb-3">
                            <label className="form-label">Contractor</label>
                            <Select
                              classNamePrefix="react-select"
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              options={contractors}
                              placeholder="Choose emp type"
                            />
                          </div>
                        </div> */}
                    </div>
                  </div>
                </div>
              </div>

              {/* Personal Details */}
              <div className="accordion-item border mb-4" id="PersonalDetails">
                <h2 className="accordion-header" id="headingSpacingTwo">
                  <div
                    className="accordion-button collapsed bg-white"
                    data-bs-toggle="collapse"
                    data-bs-target="#SpacingTwo"
                    aria-expanded="true"
                    aria-controls="SpacingTwo"
                  >
                    <div className="d-flex align-items-center justify-content-between flex-fill">
                      <h5 className="d-flex align-items-center">
                        <i className="fa-regular fa-id-badge text-primary me-2"></i>
                        <span>Personal Details</span>
                      </h5>
                    </div>
                  </div>
                </h2>
                <div
                  id="SpacingTwo"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingSpacingTwo"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      {/* <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                          <div className="mb-3">
                            <label className="form-label">Date of Birth</label>
                            <input type="date" className="form-control" />
                            value={formatDate(detailsData?.DateOfBirth)}
                            onChange={handleDetailsChange}
                          </div>
                        </div> */}
                      <div className="mb-3"></div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Email
                            <span className="text-danger ms-1"></span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter emergency contact no"
                            name="emailid"
                            value={detailsData?.emailid || ""}
                            onChange={handleDetailsChange}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Contact No1
                            <span className="text-danger ms-1"></span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter  contact no1"
                            name="EmergencyContactNo1"
                            value={detailsData?.EmergencyContactNo1 || ""}
                            onChange={handleDetailsChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Contact No2
                            <span className="text-danger ms-1"></span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter  contact no2"
                            name="EmergencyContactNo2"
                            value={detailsData?.EmergencyContactNo2 || ""}
                            onChange={handleDetailsChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">Current Address</label>
                          <textarea
                            className="form-control"
                            placeholder="Enter current address"
                            name="CurrentAddress"
                            value={detailsData?.CurrentAddress || ""}
                            onChange={handleDetailsChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Permanent Address
                          </label>
                          <textarea
                            className="form-control"
                            placeholder="Enter permanent address"
                            name="PermanentAddress"
                            value={detailsData?.PermanentAddress || ""}
                            onChange={handleDetailsChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 ">
                        <div className="d-flex align-items-center justify-content-end mb-4">
                          {!hasExistingRegData ? (
                            <button
                              type="submit"
                              className="btn btn-secondary me-2"
                              onClick={saveRegDetails}
                            >
                              {personalDetLoading ? "Saving..." : "Save"}
                            </button>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={UpdateRegDetails}
                            >
                              {personalDetLoading ? "Updating..." : "Update"}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bank Details */}
              <div className="accordion-item border mb-4" id="BankDetails">
                <h2 className="accordion-header" id="headingSpacingThree">
                  <div
                    className="accordion-button collapsed bg-white"
                    data-bs-toggle="collapse"
                    data-bs-target="#SpacingThree"
                    aria-expanded="true"
                    aria-controls="SpacingThree"
                  >
                    <div className="d-flex align-items-center justify-content-between flex-fill">
                      <h5 className="d-flex align-items-center">
                        <i className="fa-solid fa-building-columns me-2 text-primary"></i>
                        <span>Bank Details</span>
                      </h5>
                    </div>
                  </div>
                </h2>
                <div
                  id="SpacingThree"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingSpacingThree"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">Account No</label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter account no"
                            name="AccountNo"
                            value={bankData?.AccountNo}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">Account Holder</label>
                          <input
                            type="text"
                            className="form-control"
                            name="AccountHoldersName"
                            placeholder="Enter account holder name"
                            value={bankData?.AccountHoldersName}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">Bank</label>
                          <input
                            type="text"
                            className="form-control"
                            name="BankName"
                            placeholder="Enter bank name"
                            value={bankData?.BankName}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">Branch</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter branch name"
                            name="BankBranch"
                            value={bankData?.BankBranch}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">IFSC Code</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter ifsc code"
                            name="IfscCode"
                            value={bankData?.IfscCode}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-12 ">
                        <div className="d-flex align-items-center justify-content-end mb-4">
                          {!hasExistingBankData ? (
                            <button
                              type="submit"
                              className="btn btn-secondary me-2"
                              onClick={saveBankDetails}
                            >
                              {bankDetLoading ? "Saving..." : "Save"}
                            </button>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={updateBankDetails}
                            >
                              {bankDetLoading ? "Updating..." : "Update"}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Employee Proofs */}
              <div className="accordion-item border mb-4" id="EmployeeProofs">
                <h2 className="accordion-header" id="headingSpacingFour">
                  <div
                    className="accordion-button collapsed bg-white"
                    data-bs-toggle="collapse"
                    data-bs-target="#SpacingFour"
                    aria-expanded="true"
                    aria-controls="SpacingFour"
                  >
                    <div className="d-flex align-items-center justify-content-between flex-fill">
                      <h5 className="d-flex align-items-center">
                        <i className="fa-regular fa-paste text-primary me-2"></i>
                        <span>Employee Proofs</span>
                      </h5>
                    </div>
                  </div>
                </h2>
                <div
                  id="SpacingFour"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingSpacingFour"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">PAN</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter pan no"
                            name="pan"
                            value={proofsData?.pan || ""}
                            onChange={handleproofchnage}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">Aadhar</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter aadhar no"
                            name="adhaar"
                            value={proofsData?.adhaar || ""}
                            onChange={handleproofchnage}
                            maxLength={12}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">Voter Id</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter voter id"
                            name="VoterId"
                            value={proofsData?.VoterId || ""}
                            onChange={handleproofchnage}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">Upload PAN</label>

                          <input
                            type="file"
                            key={fileInputKey}
                            className="form-control"
                            accept="image/png, image/jpeg"
                            onChange={(e) => handleImageChange(e, 2)}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">Upload Aadhar</label>

                          <input
                            type="file"
                            key={fileInputKey}
                            className="form-control"
                            accept="image/png, image/jpeg"
                            onChange={(e) => handleImageChange(e, 3)}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">Upload Voter</label>

                          <input
                            type="file"
                            key={fileInputKey}
                            className="form-control"
                            accept="image/png, image/jpeg"
                            onChange={(e) => handleImageChange(e, 4)}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">PF</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter pf no"
                            name="pf"
                            value={proofsData?.pf || ""}
                            onChange={handleproofchnage}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">EPF Start Date</label>
                          <input
                            type="date"
                            className="form-control"
                            name="EPFStart"
                            value={formatDate(proofsData?.EPFStart)}
                            onChange={handleproofchnage}
                          ></input>
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">UAN</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Uan no"
                            name="uan"
                            value={proofsData?.uan || ""}
                            onChange={handleproofchnage}
                          />
                        </div>
                      </div>

                      <div className="col-lg-12 ">
                        <div className="d-flex align-items-center justify-content-end mb-4">
                          {!hasExistingproofsData ? (
                            <button
                              type="submit"
                              className="btn btn-secondary me-2"
                              onClick={saveProofDetails}
                            >
                              {proofsDetLoading ? "Saving..." : "Save"}
                            </button>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={updateProofDetails}
                            >
                              {proofsDetLoading ? "Updating..." : "Update"}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Family Details */}
              <div className="accordion-item border mb-4" id="FamilyDetails">
                <h2 className="accordion-header" id="headingSpacingFive">
                  <div
                    className="accordion-button collapsed bg-white"
                    data-bs-toggle="collapse"
                    data-bs-target="#SpacingFive"
                    aria-expanded="true"
                    aria-controls="SpacingFive"
                  >
                    <div className="d-flex align-items-center justify-content-between flex-fill">
                      <h5 className="d-flex align-items-center">
                        <i className="fa-solid fa-users text-primary me-2"></i>
                        <span>Family Details</span>
                      </h5>
                    </div>
                  </div>
                </h2>
                <div
                  id="SpacingFive"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingSpacingFive"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Memeber Name
                            <span className="text-danger ms-1"></span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Ex: Rama krishna P"
                            name="Name"
                            value={familyData?.Name || ""}
                            onChange={handlefamilychnage}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">DateOfBirth</label>
                          <input
                            type="date"
                            className="form-control"
                            name="DateOfBirth"
                            value={formatDate(familyData?.DateOfBirth)}
                            onChange={handlefamilychnage}
                          ></input>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Relation
                            <span className="text-danger ms-1"></span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Ex: Father"
                            name="Relation"
                            value={familyData?.Relation || ""}
                            onChange={handlefamilychnage}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Age<span className="text-danger ms-1"></span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter member age"
                            name="Age"
                            value={familyData?.Age}
                            onChange={handlefamilychnage || ""}
                          />
                        </div>
                      </div>

                      <div className="col-lg-12 ">
                        <div className="d-flex align-items-center justify-content-end mb-4">
                          {!hasExistingfamilyData ? (
                            <button
                              type="submit"
                              className="btn btn-secondary me-2"
                              onClick={savefamilyDetails}
                            >
                              {familyDetLoading ? "Saving..." : "Save"}
                            </button>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={updatefamilyDetails}
                            >
                              {familyDetLoading ? "Updating..." : "Update"}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Education Details */}
              <div className="accordion-item border mb-4" id="EducationDetails">
                <h2 className="accordion-header" id="headingSpacingSix">
                  <div
                    className="accordion-button collapsed bg-white"
                    data-bs-toggle="collapse"
                    data-bs-target="#SpacingSix"
                    aria-expanded="true"
                    aria-controls="SpacingSix"
                  >
                    <div className="d-flex align-items-center justify-content-between flex-fill">
                      <h5 className="d-flex align-items-center">
                        <i className="fa-solid fa-user-graduate text-primary me-2"></i>
                        <span>Education Details</span>
                      </h5>
                    </div>
                  </div>
                </h2>
                <div
                  id="SpacingSix"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingSpacingSix"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Qualification
                            <span className="text-danger ms-1">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="Qualification"
                            placeholder="Education  qualification"
                            value={educationData?.Qualification}
                            onChange={handleEducationchnage}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            College
                            <span className="text-danger ms-1">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enetr college name"
                            name="College"
                            value={educationData?.College}
                            onChange={handleEducationchnage}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            University
                            <span className="text-danger ms-1">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enetr university name"
                            name="University"
                            value={educationData?.University}
                            onChange={handleEducationchnage}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Percentage
                            <span className="text-danger ms-1">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enetr percentage"
                            name="Percentage"
                            value={educationData?.Percentage}
                            onChange={handleEducationchnage}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Upload Highest Degree Certificate
                          </label>
                          <input
                            type="file"
                            key={fileInputKey}
                            className="form-control"
                            accept="image/png, image/jpeg"
                            onChange={(e) => handleImageChange(e, 5)}
                          />
                        </div>
                        {/* <p className="mt-2">
                          File below 2 MB, Accepted File format PDF, PNG
                        </p> */}
                      </div>
                      <div className="col-lg-12 ">
                        <div className="d-flex align-items-center justify-content-end mb-4">
                          {!hasExistingEducationData ? (
                            <button
                              type="submit"
                              className="btn btn-secondary me-2"
                              onClick={saveEducationDetails}
                            >
                              {educationDetLoading ? "Saving..." : "Save"}
                            </button>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={UpdateEducationDetails}
                            >
                              {educationDetLoading ? "Updating..." : "Update"}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Files  */}
              <div className="accordion-item border mb-4" id="FilesDetails">
                <h2 className="accordion-header" id="headingSpacingSeven">
                  <div
                    className="accordion-button collapsed bg-white"
                    data-bs-toggle="collapse"
                    data-bs-target="#SpacingSeven"
                    aria-expanded="true"
                    aria-controls="SpacingSeven"
                  >
                    <div className="d-flex align-items-center justify-content-between flex-fill">
                      <h5 className="d-flex align-items-center">
                        <i className="fa-solid fa-file text-primary me-2"></i>
                        <span>Files</span>
                      </h5>
                    </div>
                  </div>
                </h2>
                <div
                  id="SpacingSeven"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingSpacingSeven"
                >
                  <div className="accordion-body border-top">
                    <div className="table-responsive">
                      <table className="table mb-0">
                        <thead>
                          <tr>
                            <th> Image Type</th>
                            <th>Uploaded</th>
                            <th>Uploaded date</th>
                            <th className="d-flex justify-content-center">
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.entries(typeLabels)?.map(([type, label]) => {
                            const matchedFile = uploadedFiles?.find(
                              (file) => file.FileType === parseInt(type),
                            );
                            return (
                              <tr key={type}>
                                <td>{label}</td>
                                <td>
                                  {matchedFile?.CreatedOn ? (
                                    <i className="fa-solid fa-check text-success fa-lg"></i>
                                  ) : (
                                    <i className="fa-solid fa-xmark text-danger fa-lg"></i>
                                  )}
                                </td>
                                <td>
                                  {matchedFile?.CreatedOn
                                    ? formatDate(matchedFile.CreatedOn)
                                    : "N/A"}
                                </td>
                                <td>
                                  <div className="edit-delete-action d-flex justify-content-center">
                                    {matchedFile?.FilePath ? (
                                      <>
                                        <Link
                                          className="me-2 p-2"
                                          onClick={() =>
                                            handlePreview(matchedFile.FilePath)
                                          }
                                        >
                                          <i className="fa-solid fa-eye"></i>
                                        </Link>
                                        <Link
                                          className="me-2 p-2"
                                          onClick={() =>
                                            handleDownload(matchedFile.FilePath)
                                          }
                                        >
                                          <i className="fa-solid fa-download"></i>
                                        </Link>
                                      </>
                                    ) : (
                                      <span className="text-muted">
                                        Not Uploaded
                                      </span>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    {previewPath && (
                      <div
                        className="image-preview-overlay"
                        style={{
                          position: "fixed",
                          top: 0,
                          left: 0,
                          width: "100vw",
                          height: "100vh",
                          backgroundColor: "rgba(0, 0, 0, 0.6)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          zIndex: 9999,
                        }}
                        onClick={closePreview}
                      >
                        <div
                          onClick={(e) => e.stopPropagation()}
                          style={{
                            backgroundColor: "#fff",
                            padding: "20px",
                            borderRadius: "10px",
                            boxShadow: "0 0 15px rgba(0,0,0,0.5)",
                            position: "relative",
                            maxWidth: "80%",
                            maxHeight: "80%",
                            overflow: "auto",
                          }}
                        >
                          <button
                            onClick={closePreview}
                            style={{
                              position: "absolute",
                              top: 10,
                              right: 10,
                              background: "#fff",
                              border: "none",
                              fontSize: "1.8rem",
                              cursor: "pointer",
                              color: "#000",
                              borderRadius: "50%",
                              width: "35px",
                              height: "35px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow: "0 0 5px rgba(0,0,0,0.3)",
                              zIndex: 10000,
                            }}
                          >
                            &times;
                          </button>

                          <div
                            style={{
                              width: "100%",
                              height: "70vh",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              position: "relative",
                            }}
                          >
                            {!isLoadingPreview && (
                              <div style={{ position: "absolute" }}>
                                <span className="text-muted">
                                  Loading image...
                                </span>
                              </div>
                            )}

                            <img
                              src={previewPath}
                              alt="Preview"
                              onLoad={() => setIsLoadingPreview(true)}
                              style={{
                                maxWidth: "100%",
                                maxHeight: "70vh",
                                display: isLoadingPreview ? "block" : "none",
                                margin: "auto",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          onClick={scrollToTop}
          className="btn border-secondary  rounded-circle d-flex align-items-center justify-content-center"
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: 999,
            width: "50px",
            height: "50px",
            backgroundColor: "white",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#092c4c"; // Bootstrap secondary
            e.currentTarget.style.color = "white";
            e.currentTarget.style.borderColor = "#092c4c";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "white";
            e.currentTarget.style.color = "#092c4c";
            e.currentTarget.style.borderColor = "#092c4c";
          }}
        >
          <i className="fa-solid fa-angle-up"></i>
        </button>
        <CommonFooter />
      </div>
      <Addunits />
      <AddCategory />
      <AddVariant />
      <AddBrand />
      <AddVarientNew />
      <div className="modal fade" id="delete-modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content p-5 px-3 text-center">
                <span className="rounded-circle d-inline-flex p-2 bg-danger-transparent mb-2">
                  <i className="ti ti-trash fs-24 text-danger"></i>
                </span>
                <h4 className="fs-20 fw-bold mb-2 mt-1">Delete Attribute</h4>
                <p className="mb-0 fs-16">
                  Are you sure you want to delete Attribute?
                </p>
                <div className="modal-footer-btn mt-3 d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary fs-13 fw-medium p-2 px-3"
                  >
                    Yes Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RollcallAdditionalDetails;
